"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _hoc = require("@package/hoc");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Form = _interopRequireDefault(require("./Form"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function HOC(_ref) {
  var data = _ref.data;

  try {
    var handleSubmit = function handleSubmit(formData) {
      dispatch((0, _functionalButton.confirmTwoFA)(token['token2FA'], formData, data['id'], data['isFile']));
    };

    var handleRefresh = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch((0, _functionalButton.refreshTwoFA)(token['token2FA']));

              case 2:
                setIsDisabled(true);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleRefresh() {
        return _ref3.apply(this, arguments);
      };
    }();

    var timerIsFinished = function timerIsFinished() {
      setIsDisabled(false);
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInProcess);
    var token = (0, _reactRedux.useSelector)(_functionalButton.selectToken);

    var _useState = (0, _react.useState)(true),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        isDisabled = _useState2[0],
        setIsDisabled = _useState2[1];

    (0, _hoc.useMount)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch((0, _functionalButton.getTwoFATokenData)(data['id'], data['isFile']));

            case 2:
              dispatch((0, _functionalButton.setInProcessAction)(false));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });

    if (inProcess) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['spinner']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null));
    }

    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      token: token,
      isDisabled: isDisabled,
      onFinished: function onFinished() {
        return timerIsFinished();
      },
      onRefresh: function onRefresh(data) {
        return handleRefresh(data);
      },
      onSubmit: function onSubmit(data) {
        return handleSubmit(data);
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;